export interface IdTypeCodeOption {
  title: string;
  value: string;
  bigo1?: string;
}

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

function looksLikeBaseCode(value: string): boolean {
  const v = trim(value);
  return !!v && /^[A-Z]\d{5}$/i.test(v);
}

/** eFiling BIGO1 abbrev stored in old idTypeName (e.g. PP) — not for Word labels */
function looksLikeEfilingAbbrev(value: string): boolean {
  const v = trim(value);
  return !!v && v.length <= 4 && /^[A-Z]+$/i.test(v) && !looksLikeBaseCode(v);
}

/** Word Share Application — B03 display name (CODE_NAME / title) */
export function resolveIdTypeDocumentLabel(code: string, options: IdTypeCodeOption[]): string {
  const cd = trim(code);
  if (!cd || !options.length) return '';
  const item = options.find((o) => o.value === cd);
  const title = trim(item?.title);
  if (title && !looksLikeBaseCode(title)) return title;
  return looksLikeBaseCode(cd) ? '' : cd;
}

/** eFiling seed — B03 BIGO1 (PP, NRIC, …) */
export function resolveIdTypeEfilingLabel(code: string, options: IdTypeCodeOption[]): string {
  const cd = trim(code);
  if (!cd || !options.length) return '';
  const item = options.find((o) => o.value === cd);
  const fromBigo1 = trim(item?.bigo1);
  if (fromBigo1) return fromBigo1;
  const title = trim(item?.title);
  if (title && !looksLikeBaseCode(title)) return title;
  return looksLikeBaseCode(cd) ? '' : cd;
}

export function resolveApplicantIdLabel(
  row: Pick<{ categoryCd?: string; idTypeCode?: string; idTypeName?: string }, 'categoryCd' | 'idTypeCode' | 'idTypeName'>,
  options: IdTypeCodeOption[] = [],
): string {
  if (trim(row.categoryCd) === 'B09001') return 'UEN';

  const code = trim(row.idTypeCode);
  if (code && options.length) {
    const fromCode = resolveIdTypeDocumentLabel(code, options);
    if (fromCode) return fromCode;
  }

  const name = trim(row.idTypeName);
  if (name && !looksLikeBaseCode(name) && !looksLikeEfilingAbbrev(name)) return name;

  return 'Identification No.';
}
